import { Pipe, PipeTransform } from '@angular/core';

// Based on: https://stackoverflow.com/questions/376373/pretty-printing-xml-with-javascript
@Pipe({
  name: 'xml',
  standalone: false
})
export class XmlPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return '';
    }

    const xmlDoc = new DOMParser().parseFromString(value.trim(), 'application/xml');
    const xsltDoc = new DOMParser().parseFromString(
      [
        '<xsl:stylesheet version="3.0" xmlns:xsl="http://www.w3.org/1999/XSL/Transform">',
        '  <xsl:strip-space elements="*"/>',
        '  <xsl:template match="node()|@*">',
        '    <xsl:copy>',
        '      <xsl:apply-templates select="node()|@*"/>',
        '    </xsl:copy>',
        '  </xsl:template>',
        '  <xsl:output indent="yes"/>',
        '</xsl:stylesheet>',
      ].join('\n'),
      'application/xml',
    );

    const xsltProcessor = new XSLTProcessor();
    xsltProcessor.importStylesheet(xsltDoc);
    const resultDoc = xsltProcessor.transformToDocument(xmlDoc);

    return new XMLSerializer().serializeToString(resultDoc);
  }
}
